import React from "react";
import { GridFooter, GridFooterContainer, GridPagination } from "@mui/x-data-grid";
import AddIcon from "src/icons/AddIcon";
import { AddNewRowButton } from "../HyroTable.styles";

const TableFooter = ({ showAddButton, onAddInlineRow, testId }) => (
  <>
    {showAddButton && <AddNewRowButton startIcon={<AddIcon />} onClick={onAddInlineRow} data-testid={`${testId}-add-new-row`}>Add New</AddNewRowButton>}
    <GridFooter>
      <GridFooterContainer>
        <GridPagination />
      </GridFooterContainer>
    </GridFooter>
  </>
);

export default TableFooter;
